/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useContext } from 'react';
import useSWR from 'swr';
import { UseSWRMutationResult } from '../../common/types/swrTypes';
import { getFromApi, putToApi } from '../../common/utils/apiHelper';
import { ConfigContext } from '../configuration/ConfigContext';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import { PropertyAssociationSettings } from './models/PropertyAssociationSettings';
import { UpdatePropertyAssociationSettingsRequest } from './models/UpdatePropertyAssociationSettingsRequest';

type UsePropertyAssociationSettingsResult = UseSWRMutationResult<PropertyAssociationSettings, 'settings'>;

export const usePropertyAssociationSettings = (): UsePropertyAssociationSettingsResult => {
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociationId } = usePropertyAssociationContext();

    const url = currentPropertyAssociationId ? `${apiBaseUrl}/propertyassociations/${currentPropertyAssociationId}/settings` : null;

    const { data, error, isLoading, mutate } = useSWR<PropertyAssociationSettings>(url);

    return {
        settings: data,
        isLoading,
        error,
        refetch: () => mutate(),
    };
};

export const getPropertyAssociationSettings = (apiBaseUrl: string, propertyAssociationId: string, onSuccess: (data: PropertyAssociationSettings) => void, onFail: () => void): void => {
    getFromApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/settings`, onSuccess, onFail);
};

export const updatePropertyAssociationSettings = (
    apiBaseUrl: string,
    propertyAssociationId: string,
    data: UpdatePropertyAssociationSettingsRequest,
    onSuccess: () => void,
    onFail: () => void,
): void => {
    putToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/settings`, data, onSuccess, onFail);
};
